//export enum SituacaoEnum {
export class StatusValidacaoAlunoEnum {
  public static Deferido={id:1, descricao:"Deferido"};
  public static Indeferido={id:0, descricao:"Indeferido"};
}
